import script from "./ScadenzeCarriWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ScadenzeCarriWidget.vue?vue&type=script&setup=true&lang=js"

import "./ScadenzeCarriWidget.vue?vue&type=style&index=0&id=92feeb26&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92feeb26"]])

export default __exports__